import React from 'react'

import { useQuery } from 'react-query'
import { WrappedFieldProps } from 'redux-form'

import Box from '@material-ui/core/Box'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import ListBox from '~/components/shared/ListBox/ListBox'
import ListBoxItem from '~/components/shared/ListBox/ListBoxItem'
import Text from '~/components/shared/Text'
import { filters } from '~/views/Search/Filters/MobileFilters/utils'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import ChevronRight from '~/assets/icons/chevron-right.svg?sprite'
import { Theme } from '~/theme/theme'

import { getListItemTextPrimary } from './categoryFilter.helpers'

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      activeItem: {
        backgroundColor: 'rgba(0, 0, 0, 0.08) !important'
      },
      count: {
        fontSize: 14,
        fontFamily: 'Prompt, sans-serif',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        minWidth: '10px',
        textAlign: 'center',
        marginLeft: '4px'
      }
    }),
  { name: 'ListBoxItem' }
)

interface Props {
  setActiveFilter: (key: string) => void
  values: any
}

const CategoryFilterMobileField = ({
  setActiveFilter,
  input,
  values
}: Props & WrappedFieldProps) => {
  const { data: subcategories } = useQuery(
    ['product_subcategories', values.by_type],
    () =>
      EmpriseGroup.getCategories({ type_name: input.value }).then(
        async (resp) => {
          const subcategories = await Deserializer.deserialize(resp)

          return subcategories
        }
      ),
    { enabled: !!values.by_type }
  )

  const classes = useStyles()

  const handleClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setActiveFilter(filters.subcategory)
  }

  return (
    <ListBox
      {...input}
      virtualized={false}
      optionSettings={{
        key: 'product_categories',
        loadOptions: () => EmpriseGroup.getMainCategories(),
        optionValue: 'name',
        optionLabel: 'name'
      }}
      hideSearch
      renderOption={(props) => {
        const primary = getListItemTextPrimary(props?.option)

        const showSubcategoryButton = !!subcategories?.length && props.selected

        return (
          <ListBoxItem
            {...props}
            hideCheckbox
            className={props.selected && classes.activeItem}
            {...(!showSubcategoryButton && { primary })}
            rightAdornment={
              showSubcategoryButton && (
                <Box display="flex" alignItems="center" onClick={handleClick}>
                  <Text
                    mr={1.5}
                    color={props.selected ? 'primary' : 'textSecondary'}
                  >
                    Subcategory
                  </Text>

                  <ChevronRight width={7} height={12} />

                  <Text component="span" className={classes.count} ml={1}>
                    {props?.option?.count}
                  </Text>
                </Box>
              )
            }
          />
        )
      }}
    />
  )
}

export default CategoryFilterMobileField
